document.addEventListener('DOMContentLoaded', () => {

    const ann = document.querySelectorAll('#announce span');

    if (!ann.length) return;

    let index = 0;

    setInterval(() => {

        ann[index].classList.remove('on');

        index = (index + 1) % ann.length;

        ann[index].classList.add('on');

    }, 4200);

});